export default {
    validate: {
        required: 'Поле обязательно для заполнения!'
    }
}
